import { render, staticRenderFns } from "./ArrendamientoCfdiRelacionado.vue?vue&type=template&id=5b9d03c4&"
import script from "./ArrendamientoCfdiRelacionado.vue?vue&type=script&lang=js&"
export * from "./ArrendamientoCfdiRelacionado.vue?vue&type=script&lang=js&"
import style0 from "./ArrendamientoCfdiRelacionado.vue?vue&type=style&index=0&id=5b9d03c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports